import React from "react";
import {connect} from "react-redux";
import Item from "../../icons/planitemicons";
import c from "../../etc/Const";
import {useDrag} from "react-dnd";
import {send_edit_cmd} from "../../etc/cmd";

const Planitemmock = ({root, type, id}) => {
    const mytype = type

    const [{ isDragging, opacity }, drag, dragPreview] = useDrag(() => ({
        type: 'planitem',
        item: {
            id: id,
            type: mytype,

        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                if (item.type === mytype) {
                    let target = {}
                    target.id = mytype + "_" + c.uuidv4().slice(-8);
                    target.type = mytype
                    target.x = dropResult.x
                    target.y = dropResult.y
                    target.module = dropResult.module
                    target.typename = 'item'

                    console.log("#########")
                    console.log(target)
                    send_edit_cmd(target)
                }
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            opacity: monitor.isDragging() ? 0.4 : 1,
        })
    }))

    return(
        <div className='bubble mock'
             style={{
                 background: "#9f9f9f",
             }}
             ref={drag}
             >
            <Item type={type} size={15}/>
        </div>
    )
}

function mapStateToProps(state, ownProps) {
    return state
}

export default connect(mapStateToProps)(Planitemmock)